import { render, staticRenderFns } from "./RolingText.vue?vue&type=template&id=3788207a&scoped=true&"
import script from "./RolingText.vue?vue&type=script&lang=js&"
export * from "./RolingText.vue?vue&type=script&lang=js&"
import style0 from "./RolingText.vue?vue&type=style&index=0&id=3788207a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3788207a",
  null
  
)

export default component.exports